import { render, staticRenderFns } from "./pullNewList.vue?vue&type=template&id=02308593&scoped=true&"
import script from "./pullNewList.vue?vue&type=script&lang=js&"
export * from "./pullNewList.vue?vue&type=script&lang=js&"
import style0 from "./pullNewList.vue?vue&type=style&index=0&id=02308593&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02308593",
  null
  
)

export default component.exports